import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getSEO } from '../seo';

export default function SEO() {
  const { pathname } = useLocation();
  useEffect(() => {
    const seo = getSEO(pathname);
    document.title = seo.title;
    const meta = (attribute: 'name' | 'property', name: string, content: string) => {
      let element = document.head.querySelector<HTMLMetaElement>(`meta[${attribute}="${name}"]`);
      if (!element) { element = document.createElement('meta'); element.setAttribute(attribute, name); document.head.appendChild(element); }
      element.content = content;
    };
    meta('name', 'description', seo.description);
    meta('name', 'robots', seo.robots);
    for (const [name, content] of Object.entries({ type: 'website', title: seo.title, description: seo.description, url: seo.url, image: seo.image, 'image:alt': seo.imageAlt, site_name: 'WB Tech Ventures', locale: 'en_US' })) meta('property', 'og:' + name, content);
    for (const [name, content] of Object.entries({ card: 'summary_large_image', title: seo.title, description: seo.description, image: seo.image, 'image:alt': seo.imageAlt })) meta('name', 'twitter:' + name, content);
    let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement('link'); canonical.rel = 'canonical'; document.head.appendChild(canonical); }
    canonical.href = seo.url;
    let schema = document.getElementById('wb-schema');
    if (!schema) { schema = document.createElement('script'); schema.id = 'wb-schema'; schema.setAttribute('type', 'application/ld+json'); document.head.appendChild(schema); }
    schema.textContent = JSON.stringify(seo.structuredData).replace(/</g, '\\u003c');
  }, [pathname]);
  return null;
}
